import Vue from "vue";

Vue.component('spark-reports', {
    created() {
        this.init();
    },

    computed: {
        users() {
            return this.$root.currentTeam.users.filter((u) => {
                return this.$root.user.id === this.$root.currentTeam.owner_id ? true : u.id === this.$root.user.id;
            });
        }
    },

    methods: {
        init() {
            $(document).ready(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
        },

        receiveReports(type, userId, teamId) {
            window.axios.post(`/api/users/report`, {type: type, user: userId, team_id: teamId});
        }
    }
});
